// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyboardKey_container__1VyxH","symbol":"KeyboardKey_symbol__1Gjl8"};